export const FETCH_MESSAGES = "FETCH_MESSAGES";
export const FETCH_CHAT_HISTORY = "FETCH_CHAT_HISTORY";
export const CREATE_MESSAGES = "CREATE_MESSAGES";
export const UPDATE_MESSAGES = "UPDATE_MESSAGES";
